export default __webpack_public_path__ + "static/media/qr.5257807c.png";